module.exports = __webpack_public_path__ + "static/img/activity_schedule.9672715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/images/activity/activity_schedule.jpg
// module id = 5T5r
// module chunks = 0